"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandaloneErrorToasts = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var React = require("react");
var ErrorListProvider_1 = require("./ErrorListProvider");
var ErrorToasts_1 = require("./ErrorToasts");
var RegisterErrorStoreInHost_1 = require("./RegisterErrorStoreInHost");
/**
 * This is a standalone component that stores AND displays errors. It creates a new error list context via the ErrorListProvider,
 * and provides register/unregister callbacks so that the host app can add errors to the list. It will also display the errors
 * as toasts.
 */
function StandaloneErrorToasts(props) {
    return (React.createElement(data_catalog_shared_1.UIActionsContext.Provider, { value: props.uiActions },
        React.createElement(ErrorListProvider_1.ErrorListProvider, null,
            React.createElement(RegisterErrorStoreInHost_1.RegisterErrorStoreInHost, { registerErrorStore: props.registerErrorStore, unregisterErrorStore: props.unregisterErrorStore }),
            React.createElement(ErrorToasts_1.ErrorToasts, null))));
}
exports.StandaloneErrorToasts = StandaloneErrorToasts;
//# sourceMappingURL=StandaloneErrorToasts.js.map